<template>
  <div>
    <yx-auto-complete
      :width="width"
      :api="api.evaluationTemplateList"
      :placeholder="placeholder"
      :immediate="immediate"
      :query-params="queryParams"
      @select="(arg) => $emit('select', arg)"
      @clear="() => $emit('clear')"
      ref="yxRef"
      />
      <!-- :keys="{ searchKey: 'commodityName', nameKey: 'goodsName' }" -->
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    width: {
      type: String,
      default: '320px',
    },
    placeholder: {
      type: String,
      default: '请选择测评模板',
    },
    immediate: {
      type: Boolean,
      default: true,
    }, // 是否获取焦点立即查询
    queryParams: {
      type: Object,
      default() {
        return {
          tagSmart: 0, // 智能测评开关 1打开 0关闭
        };
      },
    },
  },
  setup() {
    const yxRef = ref(null);
    return {
      yxRef,
      clearField() {
        yxRef.value.clearField();
      },
    };
  },
});
</script>
